import { useTranslation } from 'react-i18next';
import MainButton from '../../buttons/MainButton';
import classes from './UnloggedAlertPopUp.module.scss';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeJobs } from '../../../../utils/constants';

const UnloggedAlertPopUp = ({ alertQueries, redirectAction }) => {
  const { t } = useTranslation();
  const { width } = useWindowSize();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.settings.readytosetalert')}</p>
      <div className={classes.infoTextContainer}>
        <p className={classes.popupInfoTxt}>{`${t('dashboard.settings.createunloggedalert')}${alertQueries}.`}</p>
        <p className={classes.popupInfoTxt}>{t('common.general.loginorregister')}</p>
      </div>
      <MainButton
        size={width > responsiveSizeJobs ? 'xmedium' : 'small'}
        rounded
        forceWidth={width > responsiveSizeJobs ? '326px' : '100%'}
        action={redirectAction}
      >
        {t('common.general.getstarted')}
      </MainButton>
    </div>
  );
};

export default UnloggedAlertPopUp;
